/* eslint-disable no-restricted-syntax */
import { storageConstants } from 'src/utils/constants/storageConstants';
import { applicationTypeConstants } from 'src/utils/constants/applicationConstants';

const init = () => {
  const initExcludes = getExcludeKeys();
  deleteStoryWithoutArray(initExcludes);
  localStorage.setItem(storageConstants.applicationType, applicationTypeConstants.learner);
};

const deleteStoryWithoutArray = (initExcludes: any) => {
  for (const storageKey in localStorage) {
    if (!initExcludes.includes(storageKey)) {
      localStorage.removeItem(storageKey);
    }
  }
};

const getExcludeKeys = () => {
  const initExcludes = [
    storageConstants.vueAppApiHost,
    storageConstants.vueAppPaymentHost,
    storageConstants.naverKey,
    storageConstants.telegramBot,
    storageConstants.telegramUrl,
    storageConstants.rememberUser,
    storageConstants.idpSignOutUrl,
    storageConstants.idpService,
    storageConstants.idpServiceUrl,
    storageConstants.skillPathAuth,
    storageConstants.redirectPath,
    storageConstants.dynamicQuery,
    storageConstants.fbToken,
    storageConstants.deviceOS,
    storageConstants.showPopupDate,
  ];

  return initExcludes;
};

// task-0320: 단일 키 languageInfo. memberId 오버로드 없음.
// applied_rules: must-lrnabs009config-013, must-lrnabs009config-014
const getLanguageInfo = () => localStorage.getItem(storageConstants.languageInfo);

const setLanguageInfo = (lang: any) => {
  localStorage.setItem(storageConstants.languageInfo, lang);
};

const removeLanguageInfo = () => {
  localStorage.removeItem(storageConstants.languageInfo);
};

const setToken = (token: string) => localStorage.setItem(storageConstants.token, token);

const getToken = () => localStorage.getItem(storageConstants.token);

const removeToken = () => {
  localStorage.removeItem(storageConstants.token);
  localStorage.removeItem(storageConstants.memberId);
  // TASK-295: 로그아웃 시 learnerAppInstallLink 삭제
  localStorage.removeItem(storageConstants.learnerAppInstallLink);
  // task-0320: 로그아웃 시 단일 languageInfo 삭제. TASK-295 링크 삭제는 유지.
  localStorage.removeItem(storageConstants.languageInfo);
};

const getIdpUrl = () => {
  const idpServiceUrl = getIdpServiceUrl();
  return idpServiceUrl.idpUrl;
};

const getIdpServiceUrl = () => {
  const idpServiceUrl = localStorage.getItem(storageConstants.idpServiceUrl);
  return idpServiceUrl ? JSON.parse(idpServiceUrl) : false;
};

const getUdemyUrl = () => {
  const idpServiceUrl = getIdpServiceUrl();
  return idpServiceUrl.udemyUrl;
};

const isIdpServiceValidate = () => {
  const idpService = localStorage.getItem(storageConstants.idpService);
  return idpService ? JSON.parse(idpService) : false;
};

const getIdpSignOutUrl = () => localStorage.getItem(storageConstants.idpSignOutUrl);

// const isSkillPath = () => {
//   const skillPath = localStorage.getItem(storageConstants.skillPathAuth);
//   if (!skillPath) {
//     return false;
//   }
//   const arr = skillPath.split(",");
//   return arr.includes(localStorage.getItem(storageConstants.brandCode));
// };

const isSkillPath = () => {
  const skillPath = localStorage.getItem(storageConstants.skillPathAuth);
  if (!skillPath) {
    return false;
  }
  const arr = skillPath.split(',');
  const brandCode = localStorage.getItem(storageConstants.brandCode);
  return brandCode ? arr.includes(brandCode) : false;
};

const beforeRoute = () => localStorage.getItem(storageConstants.beforeRoute);

const removeBeforeRoute = () => localStorage.removeItem(storageConstants.beforeRoute);

const setBeforeRouteInbox = () => localStorage.setItem(storageConstants.beforeRoute, 'inbox');

const getUTCTime = () => {
  const utcTime = localStorage.getItem(storageConstants.UTCTime);
  return utcTime ? JSON.parse(utcTime) : null;
};

const isSkipPassword = () => localStorage.getItem('skipPasswordChange');

const setUTCTime = (time: any) =>
  localStorage.setItem(storageConstants.UTCTime, JSON.stringify(time));

const setPermissions = (permission: any) =>
  localStorage.setItem(storageConstants.permissions, JSON.stringify(permission));

const getPermissions = () => {
  const permissions = localStorage.getItem(storageConstants.permissions);
  return permissions ? JSON.parse(permissions) : null;
};

const getApiURl = () => localStorage.getItem(storageConstants.vueAppApiHost);

const getBrandCode = () => localStorage.getItem(storageConstants.brandCode);
const removeBrandCode = () => localStorage.removeItem(storageConstants.brandCode);

const setAppType = (type: any) => localStorage.setItem(storageConstants.appType, type);

const getAppType = () => localStorage.getItem(storageConstants.appType);

const setTotalLoginToken = (token: any) =>
  localStorage.setItem(storageConstants.totalLoginToken, token);

const getTotalLoginToken = () => localStorage.getItem(storageConstants.totalLoginToken);

const removeTotalLoginToken = () => localStorage.removeItem(storageConstants.totalLoginToken);

const removeSkipPasswordData = () => localStorage.removeItem('skipPasswordChange');

const getLoginType = (type: string) => localStorage.getItem(type);

const setLoginType = (type: string, param: any) => localStorage.setItem(type, param);

const removeLoginType = (type: string) => localStorage.removeItem(type);

const getDeviceOS = () => localStorage.getItem(storageConstants.deviceOS);

const removeFirstChar = () => localStorage.removeItem('firstChar');

const removeBgColors = () => localStorage.removeItem(storageConstants.bgColors);

const setSkipPasswordChange = (data: boolean) =>
  localStorage.setItem('skipPasswordChange', String(data));

const getUserParams = () => localStorage.getItem(storageConstants.userParams);

// TASK-295: 학습자 홈 앱 전환 유도 Alert — installLink 관리
// applied_rules: must-lrnabs009config-013 (storageConstants), must-lrnabs009config-014 (localStorageUtil)
const getLearnerAppInstallLink = () => localStorage.getItem(storageConstants.learnerAppInstallLink);

const setLearnerAppInstallLink = (link: string) =>
  localStorage.setItem(storageConstants.learnerAppInstallLink, link);

const removeLearnerAppInstallLink = () =>
  localStorage.removeItem(storageConstants.learnerAppInstallLink);

const localStorageUtil = {
  init,
  getLanguageInfo,
  setLanguageInfo,
  removeLanguageInfo,
  getToken,
  setToken,
  removeToken,
  getIdpUrl,
  getUdemyUrl,
  isIdpServiceValidate,
  getIdpServiceUrl,
  getIdpSignOutUrl,
  isSkillPath,
  beforeRoute,
  removeBeforeRoute,
  setBeforeRouteInbox,
  getUTCTime,
  setUTCTime,
  setPermissions,
  getPermissions,
  getApiURl,
  getBrandCode,
  getAppType,
  setAppType,
  setTotalLoginToken,
  getTotalLoginToken,
  removeTotalLoginToken,
  removeSkipPasswordData,
  isSkipPassword,
  removeBrandCode,
  getLoginType,
  setLoginType,
  removeLoginType,
  getDeviceOS,
  removeFirstChar,
  removeBgColors,
  setSkipPasswordChange,
  getUserParams,
  getLearnerAppInstallLink,
  setLearnerAppInstallLink,
  removeLearnerAppInstallLink,
};
export default localStorageUtil;
